
import Vue from 'vue'

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      expanded: true,
    }
  },
  mounted() {

  },
  computed: {
    icon() {
      // @ts-ignore
      return this.expanded ? 'caret-up' : 'caret-right'
    }
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded
    }
  }
})
